const NUMBER = 'Number';
const PERCENT = 'Percent';

export default Object.freeze({
    [NUMBER]: 0,
    [PERCENT]: 1,
});
